export default __webpack_public_path__ + "static/media/openNoti.bcf3e392.svg";